import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import CloseIcon from '@material-ui/icons/Close';

import Link from 'components/UI/Link/Link';

import styles from './AppliedFilter.module.scss';

type PropsType = {
  label: string;
  removeUrl: string;
} & HTMLAttributes<HTMLDivElement>;

export default function AppliedFilter({
  label,
  removeUrl,
  className,
}: PropsType): JSX.Element {
  return (
    <div className={classNames(styles.container, className)}>
      {label}
      <Link to={removeUrl} className={styles.link}>
        <CloseIcon />
      </Link>
    </div>
  );
}
